import { render, staticRenderFns } from "./UnlockAccount.vue?vue&type=template&id=5364cad2&"
import script from "./UnlockAccount.vue?vue&type=script&lang=ts&"
export * from "./UnlockAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports